<div class="col">
  <div class="pb-5">
    <button class="fullscreen-button">
      <i class="fa-solid fa-expand"></i>
    </button>
    <div>
      <div class="card-body px-0 pt-0">
        <div
          *ngIf="chatList?.length; else noChat"
          class="chat-card"
          #chatContainer
        >
          <div
            *ngFor="let chatItem of chatList"
            class="chat-item my-3 me-3"
            [ngClass]="{
              'current-user': currentUser?.id === chatItem?.createdUserId
            }"
          >
            <div
              class="d-flex align-items-center gap-2 mb-1"
              [ngClass]="{
                'flex-row-reverse': currentUser?.id !== chatItem?.createdUserId
              }"
            >
              <span class="fs-12 text-hour">{{ chatItem?.relativeTime }}</span>
              <h5 class="card-title" style="font-size: 12px; margin-top: 8px">
                {{
                  currentUser?.id === chatItem?.createdUserId
                    ? ("you" | translate)
                    : chatItem?.createdUserName
                }}
              </h5>
              <!-- User Avatars -->
              <img
                *ngIf="
                  currentUser?.id === chatItem?.createdUserId;
                  else otherUser
                "
                src="assets/media/avatars/user-profile-icon.jpg"
                alt="image"
                class="rounded-circle profile-image-size"
              />
              <ng-template #otherUser>
                <img
                  src="assets/media/avatars/user-profile-icon.jpg"
                  alt="image"
                  class="rounded-circle profile-image-size"
                />
              </ng-template>
            </div>
            <p
              class="card-text mt-6 mb-5 fs-14 p-4 rounded-4"
              style="margin: 0px !important"
              [class.bg-light-pink]="
                currentUser?.id !== chatItem?.createdUserId
              "
              [class.bg-light-blue]="
                currentUser?.id === chatItem?.createdUserId
              "
              [ngClass]="{
                'text-end': currentUser?.id === chatItem?.createdUserId
              }"
            >
              {{ chatItem?.message }}
              <span *ngIf="chatItem?.chatFiles.length">
                <i
                  (click)="
                    downloadChatFile(
                      chatItem.chatFiles[0]?.chatFileFolderPath,
                      chatItem.chatFiles[0]?.chatFileName
                    )
                  "
                  class="fa-solid fa-file-arrow-down d-block mt-1 cursor-pointer"
                ></i>
              </span>
            </p>
            <div class="separator"></div>
          </div>
        </div>

        <ng-template #noChat>
          <p class="fs-14 pb-4">
            {{ "noChatToBeDisplayed" | translate }}
          </p>
        </ng-template>

        <!-- Answer input area -->
        <div
          class="col d-flex mt-2 justify-content-between align-items-center mt-10 border-top"
        >
          <input
            type="text"
            class="form-control border-0"
            style="outline: none; box-shadow: none"
            placeholder="{{ 'answerToInternist' | translate }}"
            [(ngModel)]="messageText"
            (keydown.enter)="sendChat(consultationId)"
          />
          <label class="btn btn-link p-0">
            <div class="d-inline-flex">
              <!-- Select a file -->
              <i
                class="fa-solid fa-paperclip cursor-pointer me-3"
                (click)="handleFileClick($event)"
              >
                <div *ngIf="fileCount > 0" class="file-count">1</div>
              </i>
              <!-- Send chat -->
              <i
                (click)="
                  sendChat(consultationId);
                  $event.preventDefault();
                  $event.stopPropagation()
                "
                class="fa-regular fa-paper-plane cursor-pointer"
              ></i>
            </div>
            <input
              type="file"
              #fileInput
              style="display: none"
              (change)="handleFileUpload($event)"
            />
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
